import { useState } from "react";
import { Search } from "lucide-react";
import { useI18n } from "../context/I18nContext";

export default function SearchBar({ cities = [], onSearch, initial = {} }) {
  const { t } = useI18n();
  const [city, setCity] = useState(initial.city || "");
  const [minPrice, setMinPrice] = useState(initial.min_price || "");
  const [maxPrice, setMaxPrice] = useState(initial.max_price || "");
  const [bedrooms, setBedrooms] = useState(initial.bedrooms || "");

  const submit = (e) => {
    e?.preventDefault();
    onSearch?.({
      city: city || undefined,
      min_price: minPrice ? Number(minPrice) : undefined,
      max_price: maxPrice ? Number(maxPrice) : undefined,
      bedrooms: bedrooms ? Number(bedrooms) : undefined,
    });
  };

  const reset = () => {
    setCity(""); setMinPrice(""); setMaxPrice(""); setBedrooms("");
    onSearch?.({});
  };

  return (
    <form
      onSubmit={submit}
      className="glass rounded-full border border-black/5 shadow-[0_8px_24px_rgba(0,0,0,0.04)] px-2 py-2 flex flex-col md:flex-row items-stretch gap-2"
      data-testid="search-bar"
    >
      <div className="flex-1 px-4 py-2">
        <div className="text-[11px] uppercase tracking-wider text-[#86868b] mb-0.5">{t.filters.location}</div>
        <select
          value={city}
          onChange={(e) => setCity(e.target.value)}
          className="w-full bg-transparent outline-none text-[14px] text-[#1d1d1f]"
          data-testid="filter-city"
        >
          <option value="">{t.filters.anyLocation}</option>
          {cities.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </div>
      <div className="hidden md:block w-px bg-black/10 my-2"></div>
      <div className="flex-1 px-4 py-2">
        <div className="text-[11px] uppercase tracking-wider text-[#86868b] mb-0.5">{t.filters.minPrice}</div>
        <input
          type="number"
          value={minPrice}
          onChange={(e) => setMinPrice(e.target.value)}
          placeholder="0"
          className="w-full bg-transparent outline-none text-[14px] text-[#1d1d1f]"
          data-testid="filter-min-price"
        />
      </div>
      <div className="hidden md:block w-px bg-black/10 my-2"></div>
      <div className="flex-1 px-4 py-2">
        <div className="text-[11px] uppercase tracking-wider text-[#86868b] mb-0.5">{t.filters.maxPrice}</div>
        <input
          type="number"
          value={maxPrice}
          onChange={(e) => setMaxPrice(e.target.value)}
          placeholder="—"
          className="w-full bg-transparent outline-none text-[14px] text-[#1d1d1f]"
          data-testid="filter-max-price"
        />
      </div>
      <div className="hidden md:block w-px bg-black/10 my-2"></div>
      <div className="flex-1 px-4 py-2">
        <div className="text-[11px] uppercase tracking-wider text-[#86868b] mb-0.5">{t.filters.bedrooms}</div>
        <select
          value={bedrooms}
          onChange={(e) => setBedrooms(e.target.value)}
          className="w-full bg-transparent outline-none text-[14px] text-[#1d1d1f]"
          data-testid="filter-bedrooms"
        >
          <option value="">{t.filters.anyBedrooms}</option>
          <option value="1">1+</option>
          <option value="2">2+</option>
          <option value="3">3+</option>
          <option value="4">4+</option>
          <option value="5">5+</option>
        </select>
      </div>
      <div className="flex items-center gap-2 px-2">
        <button
          type="button"
          onClick={reset}
          className="hidden md:block text-[12px] text-[#86868b] hover:text-[#1d1d1f] px-3"
          data-testid="filter-reset"
        >
          {t.filters.reset}
        </button>
        <button
          type="submit"
          className="btn-pill btn-primary text-[13px] px-5 py-3 flex items-center gap-2"
          data-testid="filter-search-button"
        >
          <Search size={14} strokeWidth={2} />
          <span>{t.filters.search}</span>
        </button>
      </div>
    </form>
  );
}
